<script>

export default {
  name: 'OverlayError',
}
</script>

<template>
  <van-overlay show class-name="breakpoint overflow-y-auto" z-index="1000">
    <div class="h-full bg-white text-center breakpoint-container">
      <van-empty description="无效链接" image="error" />
    </div>
  </van-overlay>
</template>

<style scoped lang="scss">

</style>
